import { accountEntityName } from '../../../../../../backend/features/accounts/shared';
import { showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { formatDateCustom } from '@juvare/common-web-ui/utils';
import { showEntityImportDialog } from '@juvare/platform-sdk-react/ui/features/entity-import';
import React from 'react';
import ImportGuidelines from './ImportGuidelines';
export function showAccountImportDialog(t, csvTemplate) {
    const groupName = t('import.importGroupName', {
        date: formatDateCustom(new Date(), "MMM d yyyy HH:mm:ss 'GMT'XXX"),
    });
    const handleOnAfterImport = (groupName) => {
        showInfoSnackbar({
            message: t('import.groupCreatedMessage', { groupName: groupName }),
        });
    };
    showEntityImportDialog({
        entity: accountEntityName,
        options: {
            dialogTitle: t('panels.accounts.importCsvFile'),
            csvTemplateName: t('import.accountsTemplateFileName'),
            csvTemplate: csvTemplate,
            onAfterImport: () => handleOnAfterImport(groupName),
            additionalDialogContent: React.createElement(ImportGuidelines, null),
            metadata: { addImportedUsersToGroup: true, groupName },
        },
    });
}
